<!-- Pager Builder UNDER CONSTRUCTION -->

/*eslint no-unused-vars: "error"*/

<template>
	<div class="bld-pager-main">
		<div class="title wi8_font">Pager Builder</div>

		<br/>
		<div class="t1">Btns / Set:</div>
		<div class="val1">{{pager.btnsPerSet}}</div>
		<button @click="clickVal('btnsPerSet', 0)">0</button>
		<button @click="clickVal('btnsPerSet', 1)">1</button>
		<button @click="clickVal('btnsPerSet', 3)">3</button>
		<button @click="clickVal('btnsPerSet', 5)">5</button>
		<button @click="clickVal('btnsPerSet', 10)">10</button>
		<button @click="clickVal('btnsPerSet', 20)">20</button>
	
		<br/>
		<div class="t1">Recs / Page:</div>
		<div class="val1">{{pager.recsPerPage}}</div>
		<button @click="clickVal('recsPerPage', 0)">0</button>
		<button @click="clickVal('recsPerPage', 1)">1</button>
		<button @click="clickVal('recsPerPage', 5)">5</button>
		<button @click="clickVal('recsPerPage', 10)">10</button>
		<button @click="clickVal('recsPerPage', 12)">12</button>
		<button @click="clickVal('recsPerPage', 20)">20</button>
		
		<br/>
		<div class="t1">Cur Page</div>
		<div class="val1">{{pager.curPage}}</div>
		<button @click="clickVal('curPage', 0)">0</button>
		<button @click="clickVal('curPage', 1)">1</button>
		<button @click="clickVal('curPage', 2)">2</button>
		<button @click="clickVal('curPage', 5)">5</button>
		<button @click="clickVal('curPage', 10)">10</button>

		<br/>
		<div class="t1">Beg Rec</div>
		<div class="val1">{{pager.begRec}}</div>
		<button @click="clickVal('begRec', 0)">0</button>
		<button @click="clickVal('begRec', 1)">1</button>
		<button @click="clickVal('begRec', 5)">5</button>
		<button @click="clickVal('begRec', 10)">10</button>
		<button @click="clickVal('begRec', 20)">20</button>

		<br/>
		<div class="t1">End Rec</div>
		<div class="val1">{{pager.endRec}}</div>
		<button @click="clickVal('endRec', 0)">0</button>
		<button @click="clickVal('endRec', 1)">1</button>
		<button @click="clickVal('endRec', 5)">5</button>
		<button @click="clickVal('endRec', 10)">10</button>
		<button @click="clickVal('endRec', 20)">20</button>

		<br/>
		<div class="t1">Qty Recs</div>
		<div class="val1">{{pager.qtyRecs}}</div>
		<button @click="clickVal('qtyRecs', 0)">0</button>
		<button @click="clickVal('qtyRecs', 1)">1</button>
		<button @click="clickVal('qtyRecs', 2)">2</button>
		<button @click="clickVal('qtyRecs', 10)">10</button>
		<button @click="clickVal('qtyRecs', 20)">20</button>
		<button @click="clickVal('qtyRecs', 100)">100</button>

		<br/>
		<div class="t1">Tot Recs</div>
		<div class="val1">{{pager.totRecs}}</div>
		<button @click="clickVal('totRecs', 0)">0</button>
		<button @click="clickVal('totRecs', 1)">1</button>
		<button @click="clickVal('totRecs', 5)">5</button>
		<button @click="clickVal('totRecs', 10)">10</button>
		<button @click="clickVal('totRecs', 100)">100</button>
		<button @click="clickVal('totRecs', 1000)">1000</button>

		<br/>
		<div class="t1">Animal</div>
		<div class="val1">{{animal}}</div>
		<button @click="clickAnimal('cat')">cat</button>
		<button @click="clickAnimal('dog')">dog</button>
		<button @click="clickAnimal('pig')">pig</button>

		<br/><br/>
		<UniPager />

	</div>
</template>

<script>
import { mapState } from 'vuex';
export default {
	computed: {
		...mapState('app', ['pager', 'animal']),
	},
	methods: {
		clickAnimal(val) {
			this.$store.dispatch("app/setAnimal", val );
		},
		clickVal(key, val) {
			this.$store.dispatch("app/setPager", { [key]: val } );
		} 
	},
}
</script>

<style scoped>
	.bld-pager-main {
		height: 100%;
		background-color: #FCFCEE;
		padding: 5px;
		border: solid 2px #009;
	}
	.title {
		color: #639;
	}
	.t1 {
		display: inline-block;
		width: 80px;
		height: 24px;
		overflow: hidden;
		vertical-align: top;
		border: solid 0px #C30;
	}
	.val1 {
		display: inline-block;
		width: 50px;
		height: 24px;
		overflow: hidden;
		vertical-align: top;
		text-align: right;
		color: #090;
		padding: 0px 10px 0px 0px;
		border: solid 0px #090;
	}
	button {
		width: 50px;
	}
</style>
